import { render } from "./MobileSongs.vue?vue&type=template&id=3f546ac1"
import script from "./MobileSongs.vue?vue&type=script&lang=js"
export * from "./MobileSongs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__